module.exports = __webpack_public_path__ + "static/img/business75.d16f8e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business75.png
// module id = pleI
// module chunks = 9